'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _action = require('./action');

var initState = {
  requests: [],
  showType: 'All',
  fileFilterKey: '',
  resource: []
};
var files = ['css', 'file', 'html', 'javascript', 'jpg', 'png', 'pdf', 'json', 'svg', 'gif', 'ico', 'txt', 'xml', 'zip'];

var filterType = {
  'All': ['css', 'file', 'html', 'javascript', 'jpg', 'png', 'pdf', 'json', 'svg', 'gif', 'ico', 'txt', 'xml', 'zip', 'text', 'ssl-error'],
  'Doc': ['html'],
  'JS': ['javascript'],
  'CSS': ['css'],
  'Img': ['jpg', 'png', 'gif', 'svg', 'ico'],
  'Other': ['txt', 'xml', 'zip', 'pdf']
};

function HomeReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
  var action = arguments[1];

  switch (action.type) {
    case _action.Actions.ON_ARRIVE:
      action.data.fileType = getFileType(action.data);
      var needPush = filterType[state.showType].includes(action.data.fileType); // 过滤文件类型
      if (needPush && action.data.url.path.includes(state.fileFilterKey)) {
        // 过滤关键字
        return Object.assign({}, state, {
          requests: state.requests.concat([action.data]).slice(-200),
          resource: state.resource.concat([action.data]).slice(-200)
        });
      } else {
        return Object.assign({}, state, {
          resource: state.resource.concat([action.data]).slice(-200)
        });
      }

    case _action.Actions.CLEAR:
      return initState;

    case _action.Actions.SEARCH:
      var target = state.resource.filter(function (req) {
        return req.url.href.includes(action.keys);
      });
      var result = target.filter(function (item) {
        return filterType[state.showType].includes(item.fileType);
      });

      return Object.assign({}, state, {
        requests: result,
        fileFilterKey: action.keys
      });

    case _action.Actions.FILTER:
      var requests = state.resource.filter(function (item) {
        return filterType[action.data].includes(item.fileType);
      });
      return Object.assign({}, state, { showType: action.data }, { requests: requests });

    default:
      return state;
  }
}

function getFileType(t) {
  var _t$resHeaders = t.resHeaders,
      resHeaders = _t$resHeaders === undefined ? {} : _t$resHeaders;

  var contentType = resHeaders['content-type'] || '';
  var fileType = contentType.split(';')[0].split('/')[1] || '';
  if (t.type === 'connect') {
    return 'ssl-error';
  }

  fileType = fileType.trim();

  if (fileType.indexOf('+')) {
    fileType = fileType.split('+')[0];
  }

  if (fileType === 'jpeg') {
    fileType = 'jpg';
  } else if (fileType === 'x-javascript') {
    fileType = 'javascript';
  } else if (fileType === 'x-ico' || fileType === 'x-icon') {
    fileType = 'ico';
  }

  if (files.indexOf(fileType) === -1) {
    fileType = 'text';
  }

  return fileType;
}

exports.default = HomeReducer;


//////////////////
// WEBPACK FOOTER
// ./src/reducer.js
// module id = 192
// module chunks = 0